import {assertAndContinue} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';

import {Capability, CapabilityFeature} from './CapabilityFeatureConstants';

export function getInDevelopmentCapabilities(): Array<Capability> {
  const inDevelopmentCapabilities = Object.values(Capability).filter(
    (c) => !BenchlingConfig.IDENTITY_RELEASED_CAPABILITIES.includes(c)
  );
  return inDevelopmentCapabilities;
}

// In general, the FE gating should operate on features, not capabilities. But, it's useful to know if a
// capability is still in development so we can skip its gates before it's released so we make an exception
// for them but this should not be used for any code that operates on released capabilities.
export function getCapabilityFromFeature(feature: CapabilityFeature): Capability | null {
  const featureString: string = feature;

  // Safe to check via startsWith() because we guarantee capability keys cannot start with each other in
  // benchling/auth/capabilities/constants.py
  const capability = Object.keys(Capability).find((capability) => featureString.startsWith(capability));
  return (capability as Capability) ?? null;
}

export function isFeatureInDevelopment(
  feature: CapabilityFeature,
  // Allow configuring the inDevelopmentCapabilities list for easier testing
  inDevelopmentCapabilities: Array<Capability> = getInDevelopmentCapabilities()
): boolean {
  const capabilityFromFeature = getCapabilityFromFeature(feature);
  if (!capabilityFromFeature) {
    // If this feature does not map to a capability, throw an assertion error and defer to the normal gating
    // code to handle gracefully.
    assertAndContinue(
      false,
      'Expected capability prefix of feature to match a member of the Capability enum',
      {feature}
    );
    return false;
  }
  return inDevelopmentCapabilities.includes(capabilityFromFeature);
}
